import { Panel, Typography, Stack } from '@cast/design-system';

import { getDisplayPolicies } from './proposedPoliciesUtils';
import { ProposedPolicyCard } from './ProposedPolicyCard';
import { useAutoOptimization } from '../../../_hooks/useAutoOptimization';

export const ProposedPolicies = () => {
  const {
    state: {
      recommendations: { data: recommendation },
    },
  } = useAutoOptimization();

  if (!recommendation) {
    return null;
  }

  const displayPolicies = getDisplayPolicies(recommendation);

  return (
    <Stack flex={1} gap={16} minWidth={0} data-testid="proposed-policies">
      <Typography variant="A2">
        Proposed policies ({displayPolicies.length})
      </Typography>

      <Panel>
        {displayPolicies.map((displayPolicy) => (
          <ProposedPolicyCard
            key={`${displayPolicy.action}-${displayPolicy.policy.payload.name}`}
            displayPolicy={displayPolicy}
            recommendation={recommendation}
          />
        ))}
      </Panel>
    </Stack>
  );
};
